import styled from 'styled-components';

export const AccordionSectionComponent = styled.div`
  position: relative;
  margin-top: -4px !important;
`;

export const AccordionSectionContent = styled.div``;

// Default export
export default {
  AccordionSectionComponent,
  AccordionSectionContent,
};